<template>
  <card title="Review tags">
    <el-select
      v-model="reviewTags"
      class="clinic-review-tags__select"
      multiple
      filterable
      allow-create
      default-first-option
      placeholder="Type a tag and press Enter"
    >
      <el-option v-for="tag in reviewTags" :key="tag" :label="tag" :value="tag" />
    </el-select>
  </card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: {
      ...mapState('clinics', ['clinic']),
      reviewTags: {
        get() {
          return this.clinic.review_tags || [];
        },
        // clinics saved before the field existed have no review_tags key,
        // so it has to be added reactively instead of assigned directly
        set(tags) {
          this.$set(this.clinic, 'review_tags', tags);
        },
      },
    },
  }
</script>

<style scoped>
  .clinic-review-tags__select {
    width: 100%;
  }
</style>
